import { StringMap } from '@/shared/utils/map'
import decode from 'jwt-decode'

/**
 * Decode a jwt token
 *
 * @param jwt JWT string to decode
 */
export function decodeJwt(jwt: string): StringMap<any> {
  return decode(jwt)
}
